import { render, staticRenderFns } from "./viewCRMCase.vue?vue&type=template&id=4ccd088a"
import script from "./viewCRMCase.vue?vue&type=script&lang=js"
export * from "./viewCRMCase.vue?vue&type=script&lang=js"
import style0 from "./viewCRMCase.vue?vue&type=style&index=0&id=4ccd088a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports